import * as React from 'react';
import { Button, Col, Form, Modal, ModalProps, Row } from 'react-bootstrap';

type Props = {
  onAdd: (value: { id: string }) => void;
  loading: boolean;
} & ModalProps;
function AddABtestModal({ show, onHide, onAdd, loading }: Props) {
  // @ts-ignore
  const handleSubmit = (event) => {
    // Prevent trigger other forms
    event.preventDefault();
    event.nativeEvent.stopImmediatePropagation();

    const { value } = event.target.elements.namedItem('abtestId');

    onAdd({ id: value });
  };

  /**
   * VIEW
   */
  return (
    <Modal show={show} onHide={onHide} onSubmit={handleSubmit}>
      <Modal.Body>
        <Form>
          <Row>
            <Col xs={3}>AB Test Id</Col>
            <Col xs={6}>
              <Form.Group controlId="abtestId">
                <Form.Control required type="text" />
              </Form.Group>
            </Col>
          </Row>
          <Row className="mt-3 pl-1">
            <Button disabled={loading} type="submit">
              Create
            </Button>
          </Row>
        </Form>
      </Modal.Body>
    </Modal>
  );
}

export default AddABtestModal;
